{
  "name": "@xmaxai/sdk",
  "version": "1.1.13",
  "description": "Xmax JavaScript SDK",
  "type": "module",
  "license": "MIT",
  "author": "Xmax",
  "keywords": [
    "Xmax",
    "rtc",
    "realtime",
    "video",
    "ai",
    "sdk"
  ],
  "sideEffects": false,
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "files": [
    "dist",
    "LICENSE"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "tsup",
    "build:cn": "XMAX_SDK_REGION=cn tsup",
    "build:global": "XMAX_SDK_REGION=global tsup",
    "dev": "XMAX_SDK_ENV=dev tsup --watch",
    "typecheck": "tsc -p tsconfig.json --noEmit",
    "test": "vitest run",
    "test:watch": "vitest",
    "prepublishOnly": "npm run build && npm run test",
    "publish:cn": "node scripts/publish-sdk.mjs cn",
    "publish:global": "node scripts/publish-sdk.mjs global",
    "publish:all": "npm run publish:cn && npm run publish:global"
  },
  "dependencies": {
    "@volcengine/rtc": "^4.68.5",
    "cos-js-sdk-v5": "^1.10.1",
    "heic-to": "^1.5.2"
  },
  "devDependencies": {
    "tsup": "^8.5.0",
    "typescript": "^5.9.0",
    "vitest": "^3.2.4"
  },
  "pnpm": {
    "overrides": {
      "fix-dts-default-cjs-exports": "1.0.1"
    }
  }
}
